import React, {useEffect, useState} from 'react';
import Width from '../assets/Width';
import {ActivityIndicator} from 'react-native';
import Colors from '../assets/Color/Colors';

const DeadSimpleChat = ({roomId, channelId, userId}) => {
  let sdk;
  const [loading, setLoading] = useState(false);

  const loadScript = () => {
    (function () {
      // DON'T EDIT BELOW THIS LINE
      var d = document,
        s = d.createElement('script');
      s.src = 'https://cdn.deadsimplechat.com/sdk/1.2.1/dschatsdk.min.js';
      s.id = 'chat-script';
      d.body.appendChild(s);
      s.onload = async () => {
        try {
          sdk = new DSChatSDK(
            roomId,
            'chat-frame',
            'pub_3871506e324a6e5f63734d4f4f34514152354538464c416a574671677475456d663753326f5332344975544679676b50',
          );
          await sdk.connect();

          setLoading(false);

          // await sdk.selectChannel(channelId);
        } catch (err) {
          setLoading(false);
        }
      };
    })();
  };

  useEffect(() => {
    setLoading(true);
    loadScript();

    return () => {
      const scriptElem = document.getElementById('chat-script');
      scriptElem.remove();
    };
  }, []);
  return (
    <>
      {loading && <ActivityIndicator size="large" color={Colors.tradexBlue} />}
      <iframe
        id="chat-frame"
        src={
          'https://deadsimplechat.com/' +
          roomId +
          '?uniqueUserIdentifier=' +
          userId
        }
        style={{border: 'none'}}
        width={Width.width - 32}
        height="100%"></iframe>
    </>
  );
};

export default DeadSimpleChat;
